/**
 * url 을 받아 catalog view more 인지 반환
 * catalog view more => wavve.com/viewmore?code=UI_CODE
 * @param url
 * @returns Boolean
 */
export const isCatalogViewMore = (url = '') => {
  const regExp = /wavve\.com\/viewmore\?code=/gi
  return regExp.test(url)
}
